export default __webpack_public_path__ + "assets/f2507aed163d47ad610c71d964c711a9.svg";